import { IPriceProps } from "./PriceTypes"

import { Center } from "@chakra-ui/react"

const Price: React.FC<IPriceProps> = ({ amount, transform }) => (
  <Center fontWeight="600" w="68px" h="32px" border="1px solid" borderRadius="16px" borderColor="success" color="success" fontSize="xl" transform={transform}>
    {amount}₾
  </Center>
)

export default Price